// START-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnlineStatus } from './use-online-status';

interface OfflineNavigationGuard {
  showOfflineScreen: boolean;
  retry: () => void;
}

export const useOfflineNavigationGuard = (): OfflineNavigationGuard => {
  const isOnline = useOnlineStatus();
  const location = useLocation();
  const [showOfflineScreen, setShowOfflineScreen] = useState(false);
  const previousPathRef = useRef(location.pathname + location.search);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    if (currentPath !== previousPathRef.current) {
      previousPathRef.current = currentPath;
      if (!isOnline) {
        setShowOfflineScreen(true);
      }
    }
  }, [location, isOnline]);

  useEffect(() => {
    if (isOnline) {
      setShowOfflineScreen(false);
    }
  }, [isOnline]);

  const retry = useCallback(() => {
    if (navigator.onLine) {
      setShowOfflineScreen(false);
    }
  }, []);

  return useMemo(() => ({ showOfflineScreen, retry }), [showOfflineScreen, retry]);
};
// /END-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
